// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n_ao","toggleWrap":"styles_toggleWrap__Q24LU","content":"styles_content__18sXe","selectAreaCode":"styles_selectAreaCode__16amH"};